import React, { useState, useEffect } from 'react';
import './CustomModal.css';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const CustomPrevArrow = (props) => (
  <button
    {...props}
    type="button"
    className="slick-arrow slick-prev"
    aria-label="上一張"
    style={{ zIndex: 9999, background: 'none', border: 'none' }}
  >
    <img src="/pre.webp" alt="上一張" style={{ width: 30, height: 30 }} />
  </button>
);

const CustomNextArrow = (props) => (
  <button
    {...props}
    type="button"
    className="slick-arrow slick-next"
    aria-label="下一張"
    style={{ zIndex: 9999, background: 'none', border: 'none' }}
  >
    <img src="/next.webp" alt="下一張" style={{ width: 30, height: 30 }} />
  </button>
);

function CustomModal({ isOpen, onClose, imageSrc, barcode }) {
  const [added, setAdded] = useState(false);

  const getImageUrls = (barcode) => {
    if (!barcode) return ['/404.jpg'];
    return [
      `https://cdn.jsdelivr.net/gh/WaynezProg/product_picture/shopee/${barcode}.webp`,
      `https://cdn.jsdelivr.net/gh/WaynezProg/product_picture/all/${barcode}.webp`
    ];
  };

  useEffect(() => {
    if (!barcode) return;
    const cart = JSON.parse(localStorage.getItem('cart') || '[]');
    setAdded(cart.includes(barcode));
  }, [barcode, isOpen]);

  const handleAddToCart = (e) => {
    e.stopPropagation();
    if (!barcode) return;
    let cart = JSON.parse(localStorage.getItem('cart') || '[]');
    if (!cart.includes(barcode)) {
      cart.push(barcode);
      localStorage.setItem('cart', JSON.stringify(cart));
      setAdded(true);
    }
  };

  if (!isOpen) return null;

  const images = getImageUrls(barcode);
  const sliderSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2500,
    prevArrow: <CustomPrevArrow />,
    nextArrow: <CustomNextArrow />
  };

  return (
    <div className="custom-modal-overlay" onClick={onClose}>
      <div className="custom-modal-content" onClick={e => e.stopPropagation()}>
        <div className="image-container">
          <Slider {...sliderSettings}>
            {images.map((url, idx) => (
              <img
                key={idx}
                src={url}
                alt={`商品圖片${idx + 1}`}
                className="custom-modal-image"
                onError={e => { e.target.src = '/404.jpg'; }}
              />
            ))}
          </Slider>
        </div>
        {barcode && (
          <button
            className={`add-to-cart-btn${added ? ' added' : ''}`}
            onClick={handleAddToCart}
            disabled={added}
            style={{ marginTop: '20px' }}
          >
            {added ? '已加入願望清單' : '加入願望清單'}
          </button>
        )}
      </div>
    </div>
  );
}

export default CustomModal;